import React from 'react'
import _ from 'underscore'
import styled from 'styled-components'

import TextAreaWithPreview from 'pages/shared/TextAreaWithPreview'
import Form from 'pages/shared/Form'
import FormSection from 'pages/shared/FormSection'

import Checkbox from 'components/Checkbox'
import Textarea from 'components/Textarea'
import TextInput from 'components/TextInput'
import ListSelector from 'components/ListSelectAndSort'
import LabelledField from 'components/LabelledField'

import { screenSize } from 'styles/shared'
import { color } from 'styles/colors'

import { scrubText } from 'helpers/inputCleaners'

import { Metric, GroupMetricErrors } from 'types/DeviceMetric'
import { MetricsList } from '.'

interface Props {
  range: string,
  name: string,
  description: string,
  callToAction: string,
  unit: string,
  draft: boolean
  onChangeCallback: (event) => void
  onMetricChangeCallback: (metrics: MetricsList) => void
  deviceMetrics: Array<Metric>
  errors: GroupMetricErrors
  selectedMetrics: Array<MetricsList>
}

const GroupMetricFields = ({ selectedMetrics = [], deviceMetrics = [], onMetricChangeCallback, name, description, range, unit, callToAction, draft, onChangeCallback, errors }: Props) => {
  const getAvailableMetric = () => {
    const selectedMetricsId = selectedMetrics?.length > 0 ? _.pluck(selectedMetrics, 'id') : null

    const allDeviceMetrics = (deviceMetrics ?? []).map(({ id, name, draft, color }) => {
      return { id, title: name, tag: draft ? 'draft' : null, color }
    })

    return selectedMetricsId ? _.filter(allDeviceMetrics, metric => !_.includes(selectedMetricsId, metric.id)) : allDeviceMetrics
  }

  return (
    <FormSection title="Metric Group">
      <S.Checkbox
        label="Draft"
        checked={draft}
        errorMessage={errors?.draft}
        onChange={() => onChangeCallback({ draft: !draft })}
      />
      <S.TextInput
        label="Name"
        isRequired
        onChange={event => onChangeCallback({ name: scrubText(event.target.value, true) })}
        value={name || ''}
        errorMessage={errors?.name}
      />
      <S.TextInput
        label="Unit"
        isRequired
        onChange={event => onChangeCallback({ unit: scrubText(event.target.value, true) })}
        value={unit || ''}
        errorMessage={errors?.unit}
      />
      <S.Textarea
        label="Description"
        onChange={event => onChangeCallback({ description: scrubText(event.target.value, true) })}
        value={description || ''}
        errorMessage={errors?.description}
        isRequired
      />
      <TextAreaWithPreview
        label="Call to Action"
        value={callToAction}
        onChange={event => onChangeCallback({ callToAction: scrubText(event.target.value) })}
        errorMessage={errors?.callToAction}
      />
      <S.GroupMetricsField
        id={'metrics'}
        label={'Group Metric'}
        errorMessage={errors.metrics}
        isRequired
      >
        <ListSelector
          subTitle="Add Metrics to Group"
          selectedListLabel="Selected Metrics"
          availableListLabel="Available Metrics"
          initialSelected={selectedMetrics}
          initialAvailable={getAvailableMetric()}
          showTooltipCheckbox={false}
          onChangeCallback={(e) => onMetricChangeCallback(e)}
        />
      </S.GroupMetricsField>
      <S.TextInput
        label="Recommended Range"
        isRequired
        onChange={event => onChangeCallback({ range: scrubText(event.target.value, true) })}
        value={range || ''}
        errorMessage={errors?.range}
      />
    </FormSection>
  )
}

export default GroupMetricFields

const S = {
  Form: styled(Form)`
      max-width: 100%;
    `,
  Checkbox: styled(Checkbox)`
      width: 50%;
    `,
  Subtitle: styled.h2`
      margin-top: 25px;
      border-bottom: solid 1px;
      border-color: ${color('border')};
      padding-bottom: 5px;
      text-transform: uppercase;
    `,
  Textarea: styled(Textarea)`
      width: 50%;
  
      @media ${screenSize.small} {
        width: 100%;
      }
    `,
  GroupMetricsField: styled(LabelledField)`
      padding-top: 20px;
    `,
  TextInput: styled(TextInput)`
      width: 50%;
  
      @media ${screenSize.small} {
        width: 100%;
      }
    `
}
